import SupportService from '../support';
import { GET_USER_DATA } from '../config';

export default class UserService {
  static async getDetailedUserData() {
    try {
      return await SupportService.get(GET_USER_DATA);
    } catch (err) {
      console.error('ERRROR', err);
    }
  }
}
